@switch (true) {
<!--
===========================================================================
    START DEFAULT MODE
===========================================================================
-->
@case (workMode === "default" || workMode === "tabOrder") {


@if (appService.regionArgs.translations) {
	<button matMiniFab (mousedown)="appService.toggleTranslation()" style="position: absolute; inset-inline-end: 1rem; inset-block-start: 1rem; z-index: 1;">
		<mat-icon svgIcon="globe"></mat-icon>
	</button>
}

<div class="animated faster fadeInUp">
	<div class="brand-image" style="background-image: url(/assets/images/splash-back.jpg)">
		<!--<img [src]="$storage.brand.back">-->
		<div class="logo">
			<img [src]="$storage.brand.logo">
		</div>
	</div>
	<div class="px-5 py-1">
		<div style="text-align:center; ">
			<div class="mt-3 text-accent">
				<div style="font-size: 17px; font-weight: 500;">{{$storage.site?.name}}</div>
				@if (tableTitle) {
					<div style="font-size: 14px; font-weight: 500; color: #828282">{{ tableTitle }}</div>
				}
			</div>
			<div class="mt-3" style="font-size: 22px; font-weight: 400;">
				{{'OAT.start_prompt' |translate}}
			</div>
		</div>
		<div>
			@if (canCreateEatinOrder) {
				<button mat-flat-button color="accent" class="lg rounded btn-block mt-3" type="button" (mousedown)="createEatInOrder()">
					{{ 'OAT.order_from_the_menu' |translate }}
				</button>

				@if (canCreateTabOrder) {
					<button mat-stroked-button color="accent" class="lg rounded btn-block mt-3" type="button"
							(mousedown)="startTabOrder()">
						<mat-icon svgIcon="users" class="mr-2"></mat-icon>
						<span>{{ 'OAT.create_or_share_tab' |translate }}</span>
					</button>
				}
			}

			<div class="mt-3 text-center" style="color: #828282; font-size: 10px; font-weight: 400;">
				<div>{{'_LOYALTY.sprompt_license_tabitorder' | translate}}</div>
				<a class="inline link mr-1" (click)="appService.showContractDialog('contract')">
					{{'READ_AND_APPROVE_CONTRACT_C' | translate}},
				</a>
				<a class="inline link" (click)="appService.showContractDialog('privacy')">
					{{'READ_AND_APPROVE_CONTRACT_D' | translate}}
				</a>
			</div>

			@if (!appService.user && appService.enableLogin) {
				<button mat-stroked-button color="accent" class="lg rounded btn-block mt-3" style="height:auto; padding:10px 10px" type="button" (mousedown)="login()">
					<span class="inline">{{'auth_q_cont' | translate}}</span>
				</button>
			}
		</div>
	</div>
</div>
<app-power-by-tabit></app-power-by-tabit>
	}
<!--
===========================================================================
    START SHARED TAB
===========================================================================
-->
@case (workMode === "table") {

@if (subMode == 'share') {
<ng-container *ngTemplateOutlet="tabOrderDetails"></ng-container>
} @else {
<div class="animated faster fadeInUp">
    <div class="brand-image" style="background-image: url(/assets/images/splash-back.jpg)">
        <!--<img [src]="$storage.brand.back">-->
        <div class="logo">
            <img [src]="$storage.brand.logo">
        </div>
    </div>
    <div class="px-5 pt-3">
        <div style="text-align:center; ">
            <div class="mt-4 text-accent">
                <div style="font-size: 18px; font-weight: 500;">{{$storage.site?.name}}</div>
                <div style="font-size: 14px; font-weight: 500; color: #828282" *ngIf="ui.tableTitle">{{ui.tableTitle}}</div>
            </div>
            <!--<div class="mt-4" style="font-size: 22px; font-weight: 400;">
                {{'_TABLEO.start_prompt' |translate}}
            </div>-->
        </div>
        <div style="margin-top: 50px;">

            @if (subMode == 'general') {
            <div class="animated faster fadeInUp">
                <button mat-flat-button color="accent" class="lg rounded btn-block" type="button" (mousedown)="createTableOrder()">
                    {{'_TABLEO.new_table_order' |translate}}
                </button>

                @if(canCreateTabOrder) {
                <button mat-flat-button color="accent" class="lg rounded btn-block mt-3" type="button" (mousedown)="subMode = 'share'">
                    <mat-icon svgIcon="users" class="mr-2"></mat-icon>
                    <span>{{'OAT.create_or_share_tab' |translate}}</span>
                </button>
                }

                <button mat-stroked-button color="accent" class="lg rounded btn-block mt-3" type="button" (mousedown)="joinTableOrder()">
                    <mat-icon svgIcon="users" class="mr-2"></mat-icon>
                    <span>{{'_TABLEO.join_table_order' |translate}}</span>
                </button>
            </div>
            } @else if (subMode == 'verification') {
            <form #f="ngForm" [formGroup]="verificationForm" class="condensed-fields animated faster fadeInUp">

                <p class="text-center">
                    {{'enter_code_message' | translate}}
                    <span style="display:block" class="ltr-field">{{enteredPhone | phone}}</span>
                </p>

                <mat-form-field color="accent" appearance="outline">
                    <mat-label>{{'verification_code' | translate}}</mat-label>
                    <input name="verificationCode" matInput formControlName="verificationCode" required>
                </mat-form-field>

                <div class="mt-2" style="display:flex; align-items:center; gap:10px;">
                    <button mat-button color="accent" class="lg" type="button" (mousedown)="subMode = 'general'">
                        <mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
                        {{'back' |translate}}
                    </button>
                    <button mat-flat-button color="accent" class="lg rounded flex-grow-1" type="button" (mousedown)="applyTableOrderVerification()">
                        {{'continue' |translate}}
                    </button>
                </div>
                <button mat-button class="btn-block mt-3" (click)="resendPinCode()" color="accent">{{'resend' | translate}}</button>
            </form>
            } @else {
            <form #f="ngForm" [formGroup]="contactForm" class="condensed-fields animated faster fadeInUp">
                <mat-form-field color="accent" appearance="outline">
                    <mat-label>{{'name' | translate}}</mat-label>
                    <input #name name="name" matInput formControlName="name" required>
                </mat-form-field>

                <mat-form-field color="accent" appearance="outline" class="with-pad">
                    <mat-label>{{'mobile' | translate}}</mat-label>
                    <oao-mat-intl-tel-input [preferredCountries]="appService.regionArgs.phonePreferredCountries"
                                            [onlyCountries]="appService.regionArgs.phoneOnlyCountries"
                                            [enablePlaceholder]="true"
                                            [enableSearch]="true"
                                            [searchPlaceholder]="appService.translate('search')"
                                            format="national"
                                            name="phone"
                                            formControlName="phone"
                                            required
                                            #phone></oao-mat-intl-tel-input>
                    <mat-error *ngIf="f.form.controls['phone']?.errors?.validatePhoneNumber">{{'invalid_phone' | translate}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="subMode == 'join'">
                    <mat-label>{{'enter_order_no' | translate}}</mat-label>
                    <input #orderno name="orderNO" matInput formControlName="orderNO" required>
                </mat-form-field>

                <div class="mt-2" style="display:flex; align-items:center; gap:10px;">
                    <button mat-button color="accent" class="lg" type="button" (mousedown)="subMode = 'general'">
                        <mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
                        {{'back' |translate}}
                    </button>
                    <button mat-flat-button color="accent" class="lg rounded flex-grow-1" type="button" (mousedown)="applyTableOrder()">
                        {{(subMode == 'join' ? '_TABLEO.join_table_order' : '_TABLEO.new_table_order') |translate}}
                    </button>
                </div>
            </form>
            }

            <div class="mt-4 text-center" style="color: #828282; font-size: 10px; font-weight: 400;">
				<div>{{'_LOYALTY.sprompt_license_tabitorder' | translate}}</div>
                <a class="inline link mr-1" (click)="appService.showContractDialog('contract')">
                    {{'READ_AND_APPROVE_CONTRACT_C' | translate}},
                </a>
                <a class="inline link" (click)="appService.showContractDialog('privacy')">
                    {{'READ_AND_APPROVE_CONTRACT_D' | translate}}
                </a>
            </div>

            <ng-container *ngIf="subMode == 'general' && !appService.user && appService.enableLogin">
                <button mat-stroked-button color="accent" class="lg rounded btn-block mt-4" style="height:auto; padding:10px 10px" type="button" *ngIf="canCreateEatinOrder" (mousedown)="login()">
					<span class="inline">{{'auth_q_cont' | translate}}</span>
                </button>
            </ng-container>
        </div>
    </div>
</div>
<app-power-by-tabit></app-power-by-tabit>
}
}
}
